import draggable from './draggable'
const directives = {
  draggable,
}

// 全局注册指令
export const setupDirective = (app) => {
  Object.keys(directives).forEach((key) => {
    app.directive(key, directives[key])
  })
}
